export function getCleaningType({ сleaningType, lastTimeCleaned, homeState }: {
  сleaningType: string;
  lastTimeCleaned: string;
  homeState: string;
}) {
  if (сleaningType !== 'basic_deep_cleaning') {
    return сleaningType
  }

  if (
    (lastTimeCleaned === 'one_two_weeks_ago' && (homeState === 'quite_clean' || homeState === 'could_be_better'))
    || (lastTimeCleaned === 'one_month_ago' && homeState === 'quite_clean')
  ) {
    return 'basic'
  } else {
    return 'deep'
  }
}
